// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumAccessType } from './EnumAccessType';
import {
  EnumAccessTypeFromJSON,
  EnumAccessTypeFromJSONTyped,
  EnumAccessTypeToJSON,
  EnumAccessTypeToJSONTyped,
} from './EnumAccessType';
import type { EnumElevationStatus } from './EnumElevationStatus';
import {
  EnumElevationStatusFromJSON,
  EnumElevationStatusFromJSONTyped,
  EnumElevationStatusToJSON,
  EnumElevationStatusToJSONTyped,
} from './EnumElevationStatus';

/**
 *
 * @export
 * @interface ResponseElevationResponse
 */
export interface ResponseElevationResponse {
  /**
   * Type of access the request was for
   * @type {EnumAccessType}
   * @memberof ResponseElevationResponse
   */
  accessType?: EnumAccessType;
  /**
   * When the elevated access is expected to expire
   * @type {Date}
   * @memberof ResponseElevationResponse
   */
  estimatedExpiresAt: Date;
  /**
   * When the request was made
   * @type {Date}
   * @memberof ResponseElevationResponse
   */
  requestedAt: Date;
  /**
   * Progress of the request
   * @type {EnumElevationStatus}
   * @memberof ResponseElevationResponse
   */
  status?: EnumElevationStatus;
}

/**
 * Check if a given object implements the ResponseElevationResponse interface.
 */
export function instanceOfResponseElevationResponse(
  value: object,
): value is ResponseElevationResponse {
  if (
    !('estimatedExpiresAt' in value) ||
    value['estimatedExpiresAt'] === undefined
  )
    return false;
  if (!('requestedAt' in value) || value['requestedAt'] === undefined)
    return false;
  return true;
}

export function ResponseElevationResponseFromJSON(
  json: any,
): ResponseElevationResponse {
  return ResponseElevationResponseFromJSONTyped(json, false);
}

export function ResponseElevationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseElevationResponse {
  if (json == null) {
    return json;
  }
  return {
    accessType:
      json['access_type'] == null
        ? undefined
        : EnumAccessTypeFromJSON(json['access_type']),
    estimatedExpiresAt: new Date(json['estimated_expires_at']),
    requestedAt: new Date(json['requested_at']),
    status:
      json['status'] == null
        ? undefined
        : EnumElevationStatusFromJSON(json['status']),
  };
}

export function ResponseElevationResponseToJSON(
  json: any,
): ResponseElevationResponse {
  return ResponseElevationResponseToJSONTyped(json, false);
}

export function ResponseElevationResponseToJSONTyped(
  value?: ResponseElevationResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    access_type: EnumAccessTypeToJSON(value['accessType']),
    estimated_expires_at: value['estimatedExpiresAt'].toISOString(),
    requested_at: value['requestedAt'].toISOString(),
    status: EnumElevationStatusToJSON(value['status']),
  };
}
